import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function LoaderWrapper({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    document.body.classList.add("loading");
    const timer = setTimeout(() => {
      setLoading(false)
      document.body.classList.remove("loading");
    }, 800); 
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && (
        <div className="loader-container">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
      )}
      {children}
    </>
  );
}
